import Header from "components/Common/Header/Header";
import BloodPressureBody from "components/PatientManagement/Vital/BloodPressure/BloodPressureBody";
import React, { useEffect } from "react";

const BloodPressure = () => {
  useEffect(() => {
    document.title = "Vitals | Blood Pressure";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="patientmanagement" />
      <BloodPressureBody />
    </main>
  );
};

export default BloodPressure;
